export function interpolate(input) {
  var formatted = input;
  for (var i = 1; i < arguments.length; i++) {
    var regexp = new RegExp("\\{" + (i - 1) + "\\}", "gi");
    formatted = formatted.replace(regexp, arguments[i]);
  }
  return formatted;
}

export function ReplaceAll(string, target, replacement) {
  let newRegx = new RegExp(target || "", "g");
  return string.replace(newRegx, replacement);
}
